"use strict";
/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
(0, tslib_1.__exportStar)(require("./keyDispatcher"), exports);
(0, tslib_1.__exportStar)(require("./mouseDispatcher"), exports);
(0, tslib_1.__exportStar)(require("./touchDispatcher"), exports);



//////////////////
// WEBPACK FOOTER
// ./src/dispatchers/index.ts
// module id = 14
// module chunks = 0